import {Typography} from "@mui/material";

export const DpxInfoContent = () => {


    return {
        title: 'Data Point Xrefs',
        content: (
            <>
                <Typography paragraph>
                    Data Point Xrefs create the relationship between
                    Data Points and Data Point Attributes.
                </Typography>

                <ul>
                    <li>
                        A Data Point Xref connects one Data Point to
                        one Data Point Attribute.
                    </li>

                    <li>
                        A single Data Point can be connected to many
                        Data Point Attributes through multiple
                        Data Point Xrefs.
                    </li>

                    <li>
                        Likewise, a single Data Point Attribute can
                        be associated with many Data Points.
                    </li>

                    <li>
                        Data Point Xrefs are what allow Data Point
                        Attributes to classify, group, and organize
                        Data Points throughout the system.
                    </li>

                    <li>
                        The Order field can be assigned to control
                        the sequence in which Data Points are displayed
                        when viewed in the context of a particular
                        Data Point Attribute.
                    </li>

                    <li>
                        This ordering is commonly used in reports,
                        grids, pivot views, and other interfaces where
                        a consistent presentation of related Data Points
                        is important.
                    </li>

                    <li>
                        Without Data Point Xrefs, Data Point Attributes
                        would not be associated with any Data Points and
                        therefore could not be used for grouping,
                        filtering, or reporting.
                    </li>
                </ul>
            </>
        )
    };

};